import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { Reveal } from "@/components/Reveal";
import { INDUSTRIES } from "@/data/content";

export default function Industries() {
  useSEO(
    "Industries | Managed Teams for SaaS, E-commerce, Finance & More | Synergy Outsourcing",
    "Dedicated managed teams for professional services, construction, SaaS, e-commerce, financial services, healthcare administration and growing SMBs."
  );
  return (
    <>
      <PageHero
        eyebrow="Industries"
        lines={["Built for businesses that", "need to move faster."]}
        copy="Different industries, same requirement: capable people, structured delivery and costs that make sense as you scale."
      />
      <section className="py-14 sm:py-16" data-testid="industries-grid">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.name} delay={(i % 3) * 0.08}>
                <div data-testid={`industry-detail-${i}`} className="card-hover h-full rounded-2xl border border-white/10 bg-ink-2 p-8">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-soft text-brand">
                    <ind.icon className="h-6 w-6" aria-hidden="true" />
                  </span>
                  <h2 className="mt-5 font-display text-xl font-semibold text-white">{ind.name}</h2>
                  <p className="mt-3 text-sm leading-relaxed text-mist">{ind.copy}</p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {ind.roles.map((r) => (
                      <span key={r} className="rounded-full border border-white/10 bg-white/[0.03] px-3 py-1 text-xs text-slate-300">
                        {r}
                      </span>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.2}>
              <Link
                to="/get-your-team"
                data-testid="industries-cta-card"
                className="card-hover group flex h-full min-h-[220px] flex-col items-start justify-between rounded-2xl border border-brand/30 bg-brand-soft/50 p-8"
              >
                <div>
                  <h2 className="font-display text-xl font-semibold text-white">Your industry, your roles.</h2>
                  <p className="mt-3 text-sm leading-relaxed text-mist">
                    If your business needs capacity, we can likely build the team. Tell us what you're looking for.
                  </p>
                </div>
                <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand px-6 py-3 text-sm font-semibold text-ink transition-colors group-hover:bg-brand-bright">
                  Build Your Team
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
